import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  display: flex;

  & > div {
    flex: 1;
  }
`

export {
    Container
}
